export default __webpack_public_path__ + "static/media/homework.e001833d.png";